import React, { useState, FC } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { AppRoutes } from '@/routes';
import { useTranslate } from '@/translations';
import {
  PageContainer,
  Title,
  faFileUpload,
  DragUpload,
} from '@/ui/components';
import { useUploadBillOfLading } from '@/api/BillOfLading';
import { acceptFiles, MAX_FILE_SIZE } from '@/utils/constants';
import { UploadFile } from 'antd';

export const AppUploadFile: FC = () => {
  const { t } = useTranslate();
  const { accent } = useTheme();
  const { movementId } = useParams();
  const [file, setFile] = useState<ArrayBuffer | string | null>(null);
  const [fileName, setFileName] = useState('');

  const { mutateAsync: uploadMutateAsync, isSuccess } = useUploadBillOfLading();

  const handleUploadFile = async () => {
    if (movementId) {
      await uploadMutateAsync({
        movementId: Number(movementId),
        data: { billOfLadingFileBase64: file, fileName },
      });
    }
  };

  const handleValueChange = (files: UploadFile[]) => {
    if (files.length === 0) {
      setFile(null);
      setFileName('');
      return;
    }

    const item = files[0].originFileObj as File;
    if (!item) return;

    const reader = new FileReader();
    reader.onload = ({ target }) => {
      if (target?.result) {
        setFile(target.result);
        setFileName(item.name);
      }
    };
    reader.readAsDataURL(item); // convert to base64 string
  };

  if (isSuccess) {
    return <Navigate replace to={AppRoutes.order} />;
  }

  return (
    <PageContainer>
      <Title
        title={t('billOfLadingUpload')}
        icon={faFileUpload}
        color={accent}
      />
      <DragUpload
        accept={acceptFiles}
        maxFileSize={MAX_FILE_SIZE}
        onFileChanged={handleValueChange}
        onUpload={handleUploadFile}
      />
    </PageContainer>
  );
};
